// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"BY-z","subtitle":"CY-z","wrapper":"DY-z","leftArrow":"EY-z","rightArrow":"FY-z"};